import { z } from 'zod';
import { UserIdSchema } from './common';

/**
 * Módulos auditables. Mantener sincronizado con los bounded contexts.
 */
export const AuditModuleSchema = z.enum([
  'Sistema',
  'Pacientes',
  'Procedimientos',
  'Consentimiento',
  'Anestesia',
  'Hoja de gasto',
  'Usuarios',
  'Configuración',
  'Reportes',
  'Patología',
  'Portal',
  // Resultados de procedimientos (PDFs/imágenes entregados al paciente).
  // Subirlos y borrarlos son operaciones sobre documentación clínica: deben
  // dejar traza igual que consentimiento, anestesia u hoja de gasto.
  'Resultados',
]);
export type AuditModule = z.infer<typeof AuditModuleSchema>;

/**
 * Verbos de auditoría — usar constantes; no strings libres en el código.
 * Cualquier nuevo verbo debe declararse aquí para garantizar searchability.
 */
export const AuditActionSchema = z.enum([
  'Inicio de sesión',
  'Cierre de sesión',
  'Intento fallido de inicio',
  'Creó',
  'Actualizó',
  'Eliminó',
  'Firmó consentimiento',
  'Firmó registro',
  'Firmó hoja',
  'Creó borrador',
  'Cerró episodio',
  'Anuló episodio',
  'Actualizó estado del paciente',
  'Exportó',
  'Consultó',
  'Cambió rol',
  'Bloqueó usuario',
  'Activó usuario',
  'Cambió contraseña',
  'Entregó resultado de patología',
]);
export type AuditAction = z.infer<typeof AuditActionSchema>;

export const AuditLogEntrySchema = z.object({
  id: z.string().uuid(),
  fecha: z.string().datetime(),
  usuarioId: UserIdSchema,
  usuarioNombre: z.string(),
  modulo: AuditModuleSchema,
  accion: AuditActionSchema,
  entidad: z.string().max(120),
  ip: z.string().ip().optional(),
  userAgent: z.string().max(500).optional(),
  /**
   * Hash chain — cada registro incluye el hash SHA-256 del anterior.
   * Permite detectar modificaciones a posteriori (tamper-evident).
   */
  hashAnterior: z.string().length(64),
  hash: z.string().length(64),
  metadata: z.record(z.unknown()).optional(),
});
export type AuditLogEntry = z.infer<typeof AuditLogEntrySchema>;
